var _style, _linearGradient, _defs, _clipPath, _g, _g2, _g3, _g4, _g5, _g6, _circle, _circle2, _circle3, _circle4, _defs2, _clipPath2, _path, _defs3, _clipPath3, _path2, _path3, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _circle5, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1283.71",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{opacity:.5}.st4{fill:#fff}.st48,.st5,.st7{fill:none;stroke:#fff;stroke-width:2.1221;stroke-miterlimit:10}.st48,.st7{stroke-width:.5}.st48{stroke-width:3}.st109{opacity:.81}.st166{opacity:.77}.st168{stroke-width:2}.st168,.st171,.st179{fill:none;stroke:#fff;stroke-miterlimit:10}.st171{opacity:.5;stroke-width:50}.st179{stroke-width:2;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.21
    }
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 161.84,
    x2: 1673.7,
    y1: -153.36,
    y2: 1358.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57EE6A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AE1A1",
    offset: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8AD",
    offset: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M-5.72 0h1925.6v1283.7H-5.72z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 59.92c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 59.92c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 59.92,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 99.22c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 99.22c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 99.22,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 138.51c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 138.51c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 138.51,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 177.81c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 177.81c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 177.81,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 217.1c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 217.1c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 217.1,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.93 256.4c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 102.66,
    cy: 256.4,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 141.96,
    cy: 256.4,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M185.81 256.4c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 220.55,
    cy: 256.4,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 259.84,
    cy: 256.4,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 299.14,
    cy: 256.4,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 338.43,
    cy: 256.4,
    r: 4.56
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 743.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 782.36,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 821.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 860.95,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 900.24,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 939.54,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1628.6,
    cy: 978.83,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1628.6 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.05 4.56-4.56 4.56zM1589.3 747.62c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 786.92c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 826.21c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 865.51c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 904.8c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 944.1c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 983.39c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56zM1589.3 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 743.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 782.36,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 821.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 860.95,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 900.24,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 939.54,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1550,
    cy: 978.83,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1550 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.05 4.56-4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 743.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 782.36,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 821.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 860.95,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 900.24,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 939.54,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1510.8,
    cy: 978.83,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1510.8 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 743.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 782.36,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 821.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 860.95,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 900.24,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 939.54,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1471.5,
    cy: 978.83,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1471.5 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.05 4.56-4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 743.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 782.36,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 821.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 860.95,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 900.24,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 939.54,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1432.2,
    cy: 978.83,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1432.2 1022.7c-2.52 0-4.56-2.04-4.56-4.56s2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56-2.04 4.56-4.56 4.56z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1127 154.72c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56c2.51 0 4.56 2.04 4.56 4.56zM1166.3 154.72c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56zM1205.6 154.72c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56zM1127 194.02c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56c2.51 0 4.56 2.04 4.56 4.56zM1166.3 194.02c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56zM1205.6 194.02c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56zM1127 233.31c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56c2.51 0 4.56 2.04 4.56 4.56zM1166.3 233.31c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56zM1205.6 233.31c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.04 4.56 4.56z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M760.11 503.84c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56a4.57 4.57 0 0 1 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 794.84,
    cy: 503.84,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 834.14,
    cy: 503.84,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M760.11 543.14c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56c2.51 0 4.56 2.04 4.56 4.56z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 794.84,
    cy: 543.14,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 834.14,
    cy: 543.14,
    r: 4.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M760.11 582.43c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56a4.57 4.57 0 0 1 4.56 4.56zM799.4 582.43c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.05 4.56 4.56zM838.7 582.43c0 2.52-2.04 4.56-4.56 4.56s-4.56-2.04-4.56-4.56 2.04-4.56 4.56-4.56 4.56 2.05 4.56 4.56z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1495.7 3.28-165.6 165.55M1491.4-.93l-165.5 165.54M1487.2-5.15l-165.5 165.54M1483-9.37l-165.5 165.55M1478.8-13.59l-165.6 165.55M1474.6-17.81 1309 147.74M1470.4-22.02l-165.6 165.54M1466.1-26.24 1300.6 139.3M1461.9-30.46l-165.5 165.55M1457.7-34.68l-165.5 165.55M1453.5-38.9l-165.6 165.55M1449.3-43.11l-165.6 165.54M1445-47.33l-165.5 165.54M1440.8-51.55 1275.3 114M1436.6-55.77l-165.5 165.55M1432.4-59.99l-165.6 165.55M1428.2-64.2l-165.6 165.54M1424-68.42 1258.4 97.12M1419.7-72.64 1254.2 92.91M1415.5-76.86 1250 88.69M1411.3-81.08 1245.8 84.47M1407.1-85.29 1241.5 80.25M1402.9-89.51 1237.3 76.03M1398.6-93.73 1233.1 71.82M1394.4-97.95 1228.9 67.6M1390.2-102.17 1224.7 63.38M1386-106.38 1220.4 59.16M1381.8-110.6 1216.2 54.94M1377.6-114.82 1212 50.72M1373.3-119.04 1207.8 46.51M1369.1-123.26 1203.6 42.29M1364.9-127.47 1199.4 38.07M1360.7-131.69 1195.1 33.85M1356.5-135.91 1190.9 29.63M1352.2-140.13 1186.7 25.42M1348-144.35 1182.5 21.2M1343.8-148.56 1178.3 16.98M1339.6-152.78 1174 12.76M1335.4-157 1169.8 8.54M1331.2-161.22 1165.6 4.33M1326.9-165.44 1161.4.11M1322.7-169.65 1157.2-4.11M1318.5-173.87 1153-8.33M1314.3-178.09 1148.7-12.55M1310.1-182.31 1144.5-16.76M1305.8-186.53 1140.3-20.98M1301.6-190.74 1136.1-25.2M1297.4-194.96 1131.9-29.42M1293.2-199.18 1127.6-33.64M1289-203.4 1123.4-37.85M1284.8-207.62 1119.2-42.07M1280.5-211.83 1115-46.29"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1171 1343.4-165.6 165.5M1166.7 1339.2l-165.5 165.5M1162.5 1335l-165.53 165.5M1158.3 1330.7l-165.55 165.6M1154.1 1326.5l-165.56 165.6M1149.9 1322.3l-165.58 165.5M1145.6 1318.1l-165.5 165.5M1141.4 1313.9l-165.52 165.5M1137.2 1309.6l-165.54 165.6M1133 1305.4 967.45 1471M1128.8 1301.2l-165.57 165.6M1124.6 1297l-165.59 165.5M1120.3 1292.8l-165.51 165.5M1116.1 1288.6l-165.53 165.5M1111.9 1284.3l-165.54 165.6M1107.7 1280.1l-165.56 165.6M1103.5 1275.9l-165.58 165.5M1099.2 1271.7l-165.5 165.5M1095 1267.5 929.48 1433M1090.8 1263.2l-165.53 165.6M1086.6 1259l-165.55 165.6M1082.4 1254.8l-165.57 165.6M1078.2 1250.6l-165.59 165.5M1073.9 1246.4l-165.51 165.5M1069.7 1242.2l-165.52 165.5M1065.5 1237.9l-165.54 165.6M1061.3 1233.7l-165.56 165.6M1057.1 1229.5 891.52 1395M1052.8 1225.3l-165.5 165.5M1048.6 1221.1l-165.51 165.5M1044.4 1216.8l-165.53 165.6M1040.2 1212.6l-165.55 165.6M1036 1208.4 870.43 1374M1031.8 1204.2l-165.59 165.5M1027.5 1200 862 1365.5M1023.3 1195.8l-165.52 165.5M1019.1 1191.5l-165.54 165.6M1014.9 1187.3l-165.56 165.6M1010.7 1183.1l-165.58 165.5M1006.4 1178.9l-165.49 165.5M1002.2 1174.7l-165.51 165.5M998.02 1170.4 832.47 1336M993.8 1166.2l-165.55 165.6M989.58 1162l-165.55 165.6M985.36 1157.8l-165.54 165.5M981.14 1153.6 815.6 1319.1M976.93 1149.4l-165.55 165.5M972.71 1145.1l-165.55 165.6M968.49 1140.9l-165.55 165.6M964.27 1136.7l-165.54 165.5M960.05 1132.5 794.51 1298M955.84 1128.3l-165.55 165.5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    r: 361.89
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.561,
      strokeMiterlimit: 10
    },
    r: 354.78
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.622,
      strokeMiterlimit: 10
    },
    r: 347.66
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.6829,
      strokeMiterlimit: 10
    },
    r: 340.55
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7439,
      strokeMiterlimit: 10
    },
    r: 333.43
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.8049,
      strokeMiterlimit: 10
    },
    r: 326.32
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.8659,
      strokeMiterlimit: 10
    },
    r: 319.2
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.9268,
      strokeMiterlimit: 10
    },
    r: 312.09
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.9878,
      strokeMiterlimit: 10
    },
    r: 304.97
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0488,
      strokeMiterlimit: 10
    },
    r: 297.86
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1098,
      strokeMiterlimit: 10
    },
    r: 290.75
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1707,
      strokeMiterlimit: 10
    },
    r: 283.63
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2317,
      strokeMiterlimit: 10
    },
    r: 276.52
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2927,
      strokeMiterlimit: 10
    },
    r: 269.4
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3537,
      strokeMiterlimit: 10
    },
    r: 262.29
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4146,
      strokeMiterlimit: 10
    },
    r: 255.17
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4756,
      strokeMiterlimit: 10
    },
    r: 248.06
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5366,
      strokeMiterlimit: 10
    },
    r: 240.94
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5976,
      strokeMiterlimit: 10
    },
    r: 233.83
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6585,
      strokeMiterlimit: 10
    },
    r: 226.71
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7195,
      strokeMiterlimit: 10
    },
    r: 219.6
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7805,
      strokeMiterlimit: 10
    },
    r: 212.48
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.8415,
      strokeMiterlimit: 10
    },
    r: 205.37
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9024,
      strokeMiterlimit: 10
    },
    r: 198.25
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9634,
      strokeMiterlimit: 10
    },
    r: 191.14
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0244,
      strokeMiterlimit: 10
    },
    r: 184.03
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0854,
      strokeMiterlimit: 10
    },
    r: 176.91
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1463,
      strokeMiterlimit: 10
    },
    r: 169.8
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2073,
      strokeMiterlimit: 10
    },
    r: 162.68
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2683,
      strokeMiterlimit: 10
    },
    r: 155.57
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3293,
      strokeMiterlimit: 10
    },
    r: 148.45
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3902,
      strokeMiterlimit: 10
    },
    r: 141.34
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.4512,
      strokeMiterlimit: 10
    },
    r: 134.22
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.5122,
      strokeMiterlimit: 10
    },
    r: 127.11
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.5732,
      strokeMiterlimit: 10
    },
    r: 119.99
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.6341,
      strokeMiterlimit: 10
    },
    r: 112.88
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.6951,
      strokeMiterlimit: 10
    },
    r: 105.76
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 746.455 -46.392)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.7561,
      strokeMiterlimit: 10
    },
    r: 98.65
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-84.301 746.424 -46.402)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.8171,
      strokeMiterlimit: 10
    },
    r: 91.53
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-84.704 746.464 -46.398)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.878,
      strokeMiterlimit: 10
    },
    r: 84.42
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-85.084 746.465 -46.4)",
    cx: 746.45,
    cy: -46.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.939,
      strokeMiterlimit: 10
    },
    r: 77.3
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    transform: "rotate(-85.446 746.502 -46.42)",
    cx: 746.45,
    cy: -46.4,
    r: 70.19
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.79
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    r: 236.8
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.5862,
      strokeMiterlimit: 10
    },
    r: 230.47
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.6724,
      strokeMiterlimit: 10
    },
    r: 224.14
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7586,
      strokeMiterlimit: 10
    },
    r: 217.81
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.8448,
      strokeMiterlimit: 10
    },
    r: 211.48
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.931,
      strokeMiterlimit: 10
    },
    r: 205.15
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0172,
      strokeMiterlimit: 10
    },
    r: 198.82
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1034,
      strokeMiterlimit: 10
    },
    r: 192.5
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1897,
      strokeMiterlimit: 10
    },
    r: 186.17
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2759,
      strokeMiterlimit: 10
    },
    r: 179.84
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3621,
      strokeMiterlimit: 10
    },
    r: 173.51
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4483,
      strokeMiterlimit: 10
    },
    r: 167.18
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5345,
      strokeMiterlimit: 10
    },
    r: 160.85
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6207,
      strokeMiterlimit: 10
    },
    r: 154.52
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7069,
      strokeMiterlimit: 10
    },
    r: 148.19
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7931,
      strokeMiterlimit: 10
    },
    r: 141.86
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.8793,
      strokeMiterlimit: 10
    },
    r: 135.53
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9655,
      strokeMiterlimit: 10
    },
    r: 129.21
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0517,
      strokeMiterlimit: 10
    },
    r: 122.88
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1379,
      strokeMiterlimit: 10
    },
    r: 116.55
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2241,
      strokeMiterlimit: 10
    },
    r: 110.22
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3103,
      strokeMiterlimit: 10
    },
    r: 103.89
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3966,
      strokeMiterlimit: 10
    },
    r: 97.56
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.4828,
      strokeMiterlimit: 10
    },
    r: 91.23
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.569,
      strokeMiterlimit: 10
    },
    r: 84.9
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1148.637 606.586)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.6552,
      strokeMiterlimit: 10
    },
    r: 78.57
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-3.572 1149.344 606.91)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.7414,
      strokeMiterlimit: 10
    },
    r: 72.24
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-2.487 1148.652 606.572)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.8276,
      strokeMiterlimit: 10
    },
    r: 65.92
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-1.301 1147.526 606.022)",
    cx: 1148.6,
    cy: 606.57,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.9138,
      strokeMiterlimit: 10
    },
    r: 59.59
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st48",
    cx: 1148.6,
    cy: 606.57,
    r: 53.26
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 207.7,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.8127,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.3357"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 201.95,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.8645,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.287"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 196.21,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.9163,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.2512"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 190.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.9681,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.1992"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 184.72,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0199,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.1601"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 457.572 501.744)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0717,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.1193"
    },
    r: 178.97
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 173.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1235,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.0767"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 167.48,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1754,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.0321"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 161.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2272,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.9854"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 156,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.279,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.9524"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 150.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3308,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.9012"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 144.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3826,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.8638"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 138.76,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4344,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.8241"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 133.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4862,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.7819"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 457.572 501.744)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.538,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.7369"
    },
    r: 127.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 121.53,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5898,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.6889"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 115.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6416,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.6375"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 110.04,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6935,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.6011"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-73.693 457.537 501.724)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7453,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.5615"
    },
    r: 104.29
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 457.572 501.744)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7971,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.5183"
    },
    r: 98.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 92.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.8489,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.471"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 87.06,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9007,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.4404"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-75.965 457.59 501.765)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9525,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.3836"
    },
    r: 81.31
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-66.578 457.554 501.74)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0043,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.3439"
    },
    r: 75.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 69.82,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0561,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.2987"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 64.08,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1079,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.2466"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 58.33,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1597,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.2144"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-70.67 457.597 501.758)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2116,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.1764"
    },
    r: 52.59
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-52.019 457.57 501.752)",
    cx: 457.58,
    cy: 501.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2634,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.1304"
    },
    r: 46.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.58,
    cy: 501.74,
    r: 41.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3152,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.0735"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st109"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 384.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0531,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.6111"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.0885,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.581"
    },
    r: 379.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 373.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1239,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.5636"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1593,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.5324"
    },
    r: 368.04
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 362.43,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.1947,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.5007"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 356.81,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.4683"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 351.2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.2655,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.4354"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 345.59,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3009,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.4152"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 339.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3363,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.3809"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 334.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.3717,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.3459"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 328.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4071,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.3239"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 323.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4425,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.2875"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 317.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.4779,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.2642"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 311.91,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5133,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.2403"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5487,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.2016"
    },
    r: 306.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 300.68,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.5841,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.1762"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 295.07,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6194,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.1502"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 289.46,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6548,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.1234"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 283.84,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.6902,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.0813"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 278.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7256,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.0528"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 272.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.761,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,5.0234"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 267.01,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.7964,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.9932"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 261.39,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.8318,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.9771"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 255.78,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.8672,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.9452"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 250.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9026,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.9122"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.8782"
    },
    r: 244.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 238.94,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 1.9734,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.8588"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.8227"
    },
    r: 233.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 227.71,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0442,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.8014"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 222.1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.0796,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.763"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 216.49,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.115,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.7397"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 210.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1504,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.6987"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 205.26,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.1858,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.673"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 199.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2212,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.6462"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 194.04,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.2566,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.6182"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 188.42,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.5889"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3274,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.5582"
    },
    r: 182.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 177.2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3628,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.526"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.3982,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.4922"
    },
    r: 171.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 165.97,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.4336,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.4758"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 160.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.469,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.4388"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 154.74,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.5044,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.4197"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 149.13,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.5398,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.3788"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 143.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.5752,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.3565"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 137.91,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.6106,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.3326"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 132.29,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.646,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.2848"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 126.68,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.6814,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.2566"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 121.07,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.7168,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.2262"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 115.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.7522,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.2177"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.7876,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.1829"
    },
    r: 109.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 104.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.823,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.145"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 1919.859 3.305)",
    cx: 1919.8,
    cy: 3.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.8584,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.1309"
    },
    r: 98.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 93,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.8938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.0865"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 87.39,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.9292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.0674"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 81.77,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2.9646,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,4.0143"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1919.8,
    cy: 3.28,
    r: 76.16,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0,3.988"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st166"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "f",
    className: "st166",
    cx: 816.64,
    cy: 809.35,
    r: 82.77
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M697.25 630.27 339.1 988.43M705.21 630.27 347.06 988.43M713.17 630.27 355.02 988.43M721.13 630.27 362.98 988.43M729.09 630.27 370.94 988.43M737.05 630.27 378.9 988.43M745.01 630.27 386.85 988.43M752.97 630.27 394.81 988.43M760.93 630.27 402.77 988.43M768.88 630.27 410.73 988.43M776.84 630.27 418.69 988.43M784.8 630.27 426.65 988.43M792.76 630.27 434.61 988.43M800.72 630.27 442.57 988.43M808.68 630.27 450.53 988.43M816.64 630.27 458.48 988.43M824.6 630.27 466.44 988.43M832.56 630.27 474.4 988.43M840.52 630.27 482.36 988.43M848.47 630.27 490.32 988.43M856.43 630.27 498.28 988.43M864.39 630.27 506.24 988.43M872.35 630.27 514.2 988.43M880.31 630.27 522.16 988.43M888.27 630.27 530.12 988.43M896.23 630.27 538.07 988.43M904.19 630.27 546.03 988.43M912.15 630.27 553.99 988.43M920.11 630.27 561.95 988.43M928.06 630.27 569.91 988.43M936.02 630.27 577.87 988.43M943.98 630.27 585.83 988.43M951.94 630.27 593.79 988.43M959.9 630.27 601.75 988.43M967.86 630.27 609.71 988.43M975.82 630.27 617.66 988.43M983.78 630.27 625.62 988.43M991.74 630.27 633.58 988.43M999.7 630.27 641.54 988.43M1007.6 630.27 649.5 988.43M1015.6 630.27 657.46 988.43M1023.6 630.27 665.42 988.43M1031.5 630.27 673.38 988.43M1039.5 630.27 681.34 988.43M1047.4 630.27 689.3 988.43M1055.4 630.27 697.25 988.43M1063.4 630.27 705.21 988.43M1071.3 630.27 713.17 988.43M1079.3 630.27 721.13 988.43M1087.2 630.27 729.09 988.43M1095.2 630.27 737.05 988.43M1103.2 630.27 745.01 988.43M1111.1 630.27 752.97 988.43M1119.1 630.27 760.93 988.43M1127 630.27 768.88 988.43M1135 630.27 776.84 988.43M1143 630.27 784.8 988.43M1150.9 630.27 792.76 988.43M1158.9 630.27 800.72 988.43M1166.8 630.27 808.68 988.43M1174.8 630.27 816.64 988.43M1182.8 630.27 824.6 988.43M1190.7 630.27 832.56 988.43M1198.7 630.27 840.52 988.43M1206.6 630.27 848.47 988.43M1214.6 630.27 856.43 988.43M1222.6 630.27 864.39 988.43M1230.5 630.27 872.35 988.43M1238.5 630.27 880.31 988.43M1246.4 630.27 888.27 988.43M1254.4 630.27 896.23 988.43M1262.3 630.27 904.19 988.43M1270.3 630.27 912.15 988.43M1278.3 630.27 920.11 988.43M1286.2 630.27 928.06 988.43M1294.2 630.27 936.02 988.43"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st109"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "d",
    className: "st109",
    cx: 1728.5,
    cy: 1309.3,
    r: 264.38
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M1685.6 880.68 835.55 1730.7M1693.5 880.68 843.54 1730.7M1701.5 880.68 851.54 1730.7M1709.5 880.68 859.53 1730.7M1717.5 880.68 867.52 1730.7M1725.5 880.68 875.51 1730.7M1733.5 880.68l-850 850.02M1741.5 880.68l-850 850.02M1749.5 880.68 899.49 1730.7M1757.5 880.68 907.48 1730.7M1765.5 880.68 915.47 1730.7M1773.5 880.68 923.46 1730.7M1781.5 880.68 931.46 1730.7M1789.4 880.68 939.45 1730.7M1797.4 880.68 947.44 1730.7M1805.4 880.68 955.43 1730.7M1813.4 880.68 963.42 1730.7M1821.4 880.68 971.42 1730.7M1829.4 880.68 979.41 1730.7M1837.4 880.68l-850 850.02M1845.4 880.68 995.39 1730.7M1853.4 880.68l-850 850.02M1861.4 880.68l-850 850.02M1869.4 880.68l-850 850.02M1877.4 880.68l-850 850.02M1885.4 880.68l-850 850.02M1893.3 880.68l-850 850.02M1901.3 880.68l-850 850.02M1909.3 880.68l-850 850.02M1917.3 880.68l-850 850.02M1925.3 880.68l-850 850.02M1933.3 880.68l-850 850.02M1941.3 880.68l-850 850.02M1949.3 880.68l-850 850.02M1957.3 880.68l-850 850.02M1965.3 880.68l-850 850.02M1973.3 880.68l-850 850.02M1981.3 880.68l-850 850.02M1989.2 880.68l-850 850.02M1997.2 880.68l-850 850.02M2005.2 880.68l-850 850.02M2013.2 880.68l-850 850.02M2021.2 880.68l-850 850.02M2029.2 880.68l-850 850.02M2037.2 880.68l-850 850.02M2045.2 880.68l-850 850.02M2053.2 880.68l-850 850.02M2061.2 880.68l-850 850.02M2069.2 880.68l-850 850.02M2077.2 880.68l-850 850.02M2085.2 880.68l-850 850.02M2093.1 880.68l-850 850.02M2101.1 880.68l-850 850.02M2109.1 880.68l-850 850.02M2117.1 880.68l-850 850.02M2125.1 880.68l-850 850.02M2133.1 880.68l-850 850.02M2141.1 880.68l-850 850.02M2149.1 880.68l-850 850.02M2157.1 880.68l-850 850.02M2165.1 880.68l-850 850.02M2173.1 880.68l-850 850.02M2181 880.68l-849.9 850.02M2189 880.68l-850 850.02M2197 880.68l-850 850.02M2205 880.68l-850 850.02M2213 880.68l-850 850.02M2221 880.68l-850 850.02M2229 880.68l-850 850.02M2237 880.68l-850 850.02M2245 880.68l-850 850.02M2253 880.68l-850 850.02M2261 880.68l-850 850.02M2269 880.68l-850 850.02M2277 880.68l-850 850.02M2285 880.68l-850 850.02M2292.9 880.68l-850 850.02M2300.9 880.68l-850 850.02M2308.9 880.68l-850 850.02M2316.9 880.68l-850 850.02M2324.9 880.68l-850 850.02M2332.9 880.68l-850 850.02M2340.9 880.68l-850 850.02M2348.9 880.68l-850 850.02M2356.9 880.68l-850 850.02M2364.9 880.68l-850 850.02M2372.9 880.68l-850 850.02M2380.8 880.68l-850 850.02M2388.8 880.68l-850 850.02M2396.8 880.68l-850 850.02M2404.8 880.68l-850 850.02M2412.8 880.68l-850 850.02M2420.8 880.68l-850 850.02M2428.8 880.68l-850 850.02M2436.8 880.68l-850 850.02M2444.8 880.68l-850 850.02M2452.8 880.68l-850 850.02M2460.8 880.68l-850 850.02M2468.8 880.68l-850 850.02M2476.8 880.68l-850 850.02M2484.8 880.68l-850 850.02M2492.7 880.68l-850 850.02M2500.7 880.68l-850 850.02M2508.7 880.68l-850 850.02M2516.7 880.68l-850 850.02M2524.7 880.68l-850 850.02M2532.7 880.68l-850 850.02M2540.7 880.68l-850 850.02M2548.7 880.68l-850 850.02M2556.7 880.68l-850 850.02M2564.7 880.68l-850 850.02M2572.7 880.68l-850 850.02M2580.6 880.68l-850 850.02"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.72
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "m-449.831 843.352 403.026-403.026L356.22 843.352l-403.025 403.026zM1516.833 440.317l403.026-403.026 403.025 403.026-403.025 403.026z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45.001 957.102 1397.518)",
    style: {
      opacity: 0.5,
      fill: "none",
      stroke: "#fff",
      strokeWidth: 30,
      strokeMiterlimit: 10
    },
    d: "M672.08 1112.5h569.97v569.97H672.08z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -3316.8,
    x2: -3316.8,
    y1: -8877.8,
    y2: -9458,
    gradientTransform: "rotate(-134.999 1484.98 -6788.137) scale(1 1.4391)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M646.18 841.16c41.61 41.61 41.61 109.07 0 150.68l-439.75 439.75c-41.61 41.61-109.07 41.61-150.68 0s-41.61-109.07 0-150.68L495.5 841.16c41.6-41.61 109.07-41.61 150.68 0z",
    style: {
      opacity: 0.5,
      fill: "url(#b)"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -3510.2,
    x2: -3510.2,
    y1: -10363,
    y2: -10746,
    gradientTransform: "rotate(-134.999 940.415 -5473.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M630.2 1130.7c19.81 19.81 19.81 51.93 0 71.74l-199.34 199.34c-19.81 19.81-51.93 19.81-71.74 0s-19.81-51.93 0-71.74l199.34-199.34c19.81-19.81 51.93-19.81 71.74 0z",
    style: {
      opacity: 0.5,
      fill: "url(#a)"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 499.44,
    x2: 278.08,
    y1: 991.32,
    y2: 1212.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M466.78 1024c26.51 26.51 26.51 69.49 0 96L70.66 1516.11c-26.51 26.51-69.49 26.51-96 0s-26.51-69.49 0-96l396.11-396.12c26.52-26.5 69.5-26.5 96.01.01z",
    style: {
      opacity: 0.5,
      fill: "url(#l)"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 4998.6,
    x2: 4998.6,
    y1: -1290.5,
    y2: -1673.8,
    gradientTransform: "rotate(45.001 1402.185 -4768.915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1485.5 233.73c-19.81-19.81-19.81-51.93 0-71.74l199.34-199.34c19.81-19.81 51.93-19.81 71.74 0s19.81 51.93 0 71.74l-199.34 199.34c-19.81 19.81-51.93 19.81-71.74 0z",
    style: {
      opacity: 0.5,
      fill: "url(#k)"
    }
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 5488.2,
    x2: 5488.2,
    y1: -1259.8,
    y2: -1643.2,
    gradientTransform: "rotate(45.001 1402.185 -4768.915)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1810.1 601.64c-19.81-19.81-19.81-51.93 0-71.74l199.34-199.34c19.81-19.81 51.93-19.81 71.74 0s19.81 51.93 0 71.74l-199.34 199.34c-19.81 19.82-51.93 19.82-71.74 0z",
    style: {
      opacity: 0.5,
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.49
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st179",
    cx: 417.42,
    cy: 222.35,
    r: 10.48
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M1134.1 933.62c0 5.79-4.69 10.48-10.48 10.48s-10.48-4.69-10.48-10.48 4.69-10.48 10.48-10.48 10.48 4.7 10.48 10.48zM806.53 416.1c0 5.79-4.69 10.48-10.48 10.48s-10.48-4.69-10.48-10.48 4.69-10.48 10.48-10.48 10.48 4.69 10.48 10.48zM70.3 757.39c0 5.79-4.69 10.48-10.48 10.48s-10.48-4.69-10.48-10.48 4.69-10.48 10.48-10.48 10.48 4.69 10.48 10.48zM176.32 450.44c0 5.79-4.69 10.48-10.48 10.48s-10.48-4.69-10.48-10.48 4.69-10.48 10.48-10.48 10.48 4.69 10.48 10.48zM1002.1 312.08v18.31M1011.2 321.24h-18.29M1772.4 924.47v18.31M1781.6 933.62h-18.4M480.24 758.61v18.31M489.39 767.77h-18.31M1416.4 1143.4v18.3M1425.6 1152.6h-18.4M1361 1143.4v18.3M1370.2 1152.6h-18.3M1305.7 1143.4v18.3M1314.8 1152.6h-18.3M176.32 324.42v18.31M185.48 333.58h-18.31M120.97 324.42v18.31M130.13 333.58h-18.31M65.62 324.42v18.31M74.78 333.58H56.47M697.92 705.68 712.17 681h-28.5zM1379.4 330.39l-14.3 24.68h28.5zM675.8 1079.5c6.21-6.21 17.1 4.68 23.31-1.53s-4.68-17.1 1.53-23.31 17.1 4.68 23.32-1.53c6.21-6.21-4.68-17.1 1.52-23.31 6.21-6.21 17.11 4.68 23.32-1.54 6.22-6.22-4.67-17.11 1.54-23.33 6.22-6.22 17.11 4.67 23.33-1.54M1217 1028.7c6.21-6.21 17.1 4.68 23.31-1.53s-4.68-17.1 1.53-23.31 17.1 4.68 23.32-1.53c6.21-6.21-4.68-17.1 1.52-23.31 6.21-6.21 17.11 4.68 23.32-1.54 6.22-6.22-4.67-17.11 1.54-23.33 6.22-6.22 17.11 4.67 23.33-1.54M1247.6 323.96c6.21-6.21 17.1 4.68 23.31-1.53s-4.68-17.1 1.53-23.31 17.1 4.68 23.32-1.53c6.21-6.21-4.68-17.1 1.52-23.31 6.21-6.21 17.11 4.68 23.32-1.54 6.22-6.22-4.67-17.11 1.54-23.33 6.22-6.22 17.11 4.67 23.33-1.54"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundDetails);
export default __webpack_public_path__ + "static/media/background_details.d8de84e2fec93130f63fec1c5a621146.svg";
export { ForwardRef as ReactComponent };